<template>
  <div class="express-sla">
    <div class="" ref="title" :style="`width:100%; height:${ height ? height : '400px' };`"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ExpressSLAChart',
  props: ['title', 'option', 'height', 'list'],
  data () {
    return {
      chart: null
    }
  },
  async mounted () {
    this.initChart()
  },
  watch: {
    option: {
      handler (val) {
        if (val) {
          try {
            this.chart.setOption(val)
          } catch (error) {
            // console.log('error', error)
          }
        }
      }
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.title)
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style></style>
